import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {LoginService} from '../../../login-service';
@Component({
  selector: 'app-servicecharge',
  templateUrl: './servicecharge.component.html',
  styleUrls: ['./servicecharge.component.scss']
})
export class ServicechargeComponent implements OnInit {

  Frombudget:any;
  Tobudget:any;
  Servicecharge:any;
  usertype:string
  addService:boolean=false;
  servicechargeList:any;
  message:any;
  type:any;
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  
  currentpage: number=1;
  
  searchText: any;
  viewed:boolean=false;
  servicechargeListDetails:any;
    MenuPermissions: string;
    userID: string;
    roleID: string;
    menuData: any;
    menuName: any;
    menuID: any;
    rolesList: any;
  servicechargeid: any;
  selectedscListid=[];
  dynamicRows: number;
  rowsOnPageSet: any[];
  rowCount: any;
  rowsOnPage: any;
  p: number;
  count: number;
savefilter: any;
    constructor(private loginService:LoginService) {
  
      this.userID=localStorage.getItem("userID");
      this.roleID=localStorage.getItem("roleID");
      // this.menuData=localStorage.getItem("menuData");
      this.MenuPermissions=localStorage.getItem("MenuPermissions");
      
      this.usertype=localStorage.getItem("userTypeid")
      
      this.GetMenusByUserType(3);
     
     }
  
    ngOnInit(): void {
      this.loginService.getselectpage(10)
      this.GetServicecharge();
      this.GetRoles();
    }
    
  /*Display add skills form*/
  Addservicecharge(){
      this.addService=true;
      this.type="New";
    }
    
    cancelSkills(){
  this.addService=false;
    }
  /* Retrieve skills records from the database*/
  GetServicecharge(){
      
      this.loginService.Getservicecharge(3).subscribe(data=>
        {
          this.servicechargeList = JSON.parse(data['_body']);
          this.servicechargeListDetails=this.servicechargeList;
          this.savefilter=this.servicechargeListDetails
          this.assigndynamicarray(this.servicechargeList)
          if(this.servicechargeListDetails.length>0){
            this.setPage(1);
          }
  
        
        });
     
   } 
   assigndynamicarray(userslist)
   {
     this.dynamicRows=10
     this.rowsOnPageSet=[];
     this.rowCount = userslist.length;
     console.log(this.rowCount,this.dynamicRows)
     while (this.dynamicRows < this.rowCount) {
       this.rowsOnPageSet.push(this.dynamicRows);
       this.dynamicRows = this.dynamicRows + 10;
       console.log(this.rowsOnPageSet)
     }
     if (!this.rowsOnPageSet.includes(this.rowCount))
       this.rowsOnPageSet.push(this.rowCount);
     if (this.rowsOnPageSet.length === 1) {
       if (this.rowsOnPageSet[0] <= 10)
         this.rowsOnPage = this.rowsOnPageSet[0];
     }
     this.rowsOnPage = this.rowsOnPageSet[0];
   }
   
  Searchtext(){
    this.servicechargeList = this.savefilter;
    
        let tempCompany = this.servicechargeList.filter(
          (item) => {
            return (
              (item.Frombudget !== null && item.Frombudget.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
              (item.Tobudget !== null && item.Tobudget.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)||
              (item.Servicecharge !== null && item.Servicecharge.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
           
            );
          }
    
        );
        this.servicechargeList = tempCompany;
        this.assigndynamicarray(tempCompany)
        // if(this.searchText=="")
        // {
        //  this.GetServicecharge();
        //  this.assigndynamicarray(this.servicechargeList)
        // }
        if(this.searchText !== ""){
          this.servicechargeListDetails = tempCompany;
          this.setPage(1);
      }else{
          this.servicechargeListDetails = this.savefilter;      
          this.assigndynamicarray(this.servicechargeList)
    
          this.setPage(1);
      }
       
  }
  GetRoles(){
    this.loginService.GetRoles(this.usertype).subscribe(data=>
      {  
              this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
  let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())
  
  if(filteRole.length>0){
    this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);
    
  }
  });
  }
  GetMenusByUserType(userTypeID){
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    
    this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
   
    let tempdata=this.menuData;
    
    this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='skills');
    
    if(this.menuData.length>0)
      {
    this.menuName=this.menuData[0]["menu_name"];
    this.menuID=this.menuData[0]["menu_id"];
      }
    
  
      
    
        });
        }
  
        changepagination(page:number){
          this.count=this.rowsOnPage
          console.log(this.rowsOnPage)
          this.loginService.getselectpage(this.rowsOnPage)
          this.loginService.getPager(this.servicechargeListDetails.length, page);
          this.setPage(page)
        }
   setPage(page: number) {
     this.p=page;
    this.pager = this.loginService.getPager(this.servicechargeListDetails.length, page);
    this.count=this.pager.pageSize
    this.pagedItems = this.servicechargeListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.servicechargeList = this.servicechargeListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  
  }
  
  /*Save and update skills in the database*/
   saveSkills(){
     
    const json={
      servicechargeidparm:this.servicechargeid,
      Frombudget:this.Frombudget,
      Tobudget:this.Tobudget,
      Servicecharge:this.Servicecharge,
     updatedbyparm:"Admin",
     createdbyparm:'Admin'
    };
  
     if(this.Frombudget===" "|| this.Frombudget===undefined ||this.Tobudget===""||this.Tobudget===undefined||this.Servicecharge===""||this.Servicecharge===undefined){
      return;
     }
     else{
   
  
    this.loginService.SaveServicecharge(json).subscribe((dataJson) => {
     
     if (dataJson['_body'].toString() === 'true') {
      if(this.type== "New"){
        // Swal.fire("Saved Successfully");
        this.loginService.showSuccess("Saved successfully!",'');
        setTimeout(() => {
          this.message = "";
        }, 5000);
        }
        else if(this.type==="Edit"){
          // Swal.fire("Updated Successfully");
          this.loginService.showSuccess("Updated successfully!",'');
        }
        
     
    
     setTimeout(() => {
       this.message = "";
     }, 5000);
     
     this.GetServicecharge();
     //this.setPage(1);
   }
   if(this.type=="New"){
     this.Frombudget="";
     this.Tobudget="";
     this.Servicecharge="";
   }
  
  this.GetServicecharge();
     });
    }
     
  }
  /*Display edit form */
  edit(row){
   
    this.type="Edit";
    this.addService=true;
   this.servicechargeid=row.id;
    this.Frombudget=row.Frombudget;
    this.Tobudget=row.Tobudget;
    this.Servicecharge=row.Servicecharge
    
  }
  /*View the skill details in the form*/
  viewskill(row){
    
    this.type="View";
    this.addService=true;
    this.viewed=true;
    this.Frombudget=row.Frombudget;
    this.Tobudget=row.Tobudget;
    this.Servicecharge=row.Servicecharge;
  }
  selectRow(id,e){
    if(e.target.checked){
     this.selectedscListid.push(e.target.id)
    }
    else{
     var index = this.selectedscListid.indexOf(e.target.id);
    this.selectedscListid.splice(index,1)
    }
  }
  DeleteSelected(){
   if(this.selectedscListid.length==0){
     return;
   }
   else{
     event.stopPropagation();
     Swal.fire({
       title: 'Are you sure?',
       text: 'You want to delete the selected rows' ,///
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Yes',
       cancelButtonText: 'No'
     }).then((result) => {
       if (result.value) {
         this.deleterows(this.selectedscListid);//
       } else if (result.dismiss === Swal.DismissReason.cancel) {
   
       }
     })
   }
  }
  deleterows(list){
 for(var i=0;i<list.length;i++){
   this.delete(list[i],'d');
   this.selectedscListid=[];
 }
  }
  /* Delete a record from the skills table by passing its id*/
  deleteservicecharge(row,isactive,text){
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to '+text+' this servicecharge',///
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.delete(row.id,isactive);//
      } else if (result.dismiss === Swal.DismissReason.cancel) {
  
      }
    })
  
  }
  
  delete(ID,isactive) {
    const json={
      servicechargeidparm:ID,
      isactive:isactive
    }
    this.loginService.DeleteServicecharge(json).subscribe(data => { 
     //  Swal.fire("Deleted successfully")    
             if(isactive=='d'){
            this.loginService.showSuccess("Deleted Successfully","");
  
          }
         else if(isactive=='y'){
          this.loginService.showSuccess("Activated Successfully","");
  
         }
         else{
          this.loginService.showSuccess("Deactivated Successfully","");
  
         }
      this.GetServicecharge();
      setTimeout(() => {
        this.message = "";
      }, 1000);
    
    })
  }
  
  

}
